/* Little Rowan homepage redesign — tabs, quick add, announcement rotation */
(function () {
  if (window.__lrHomeInit) return;
  window.__lrHomeInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initTabs(scope) {
    scope.querySelectorAll('[data-lr-tabs]').forEach(function (wrap) {
      if (wrap.__lrTabs) return;
      wrap.__lrTabs = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(n); tabs[n].focus();
          }
        });
      });
      function select(n) {
        tabs.forEach(function (t, j) {
          var on = j === n;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }

  function initRotate(scope) {
    scope.querySelectorAll('[data-lr-rotate]').forEach(function (el) {
      if (el.__lrRotate) return;
      el.__lrRotate = true;
      var items = el.querySelectorAll('.lr-announce__msg');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('lr:cart-updated'));
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) {} }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      fetch(root + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          if (typeof drawer.renderContents === 'function') {
            drawer.renderContents({ sections: s });
          } else { drawer.open(); }
        })
        .catch(function () { window.location.href = root + 'cart'; });
      return;
    }
    window.location.href = root + 'cart';
  }

  function initQuick(card) {
    if (card.__lrQuick) return;
    card.__lrQuick = true;
    var btn = card.querySelector('[data-lr-quick]');
    var panel = card.querySelector('.lr-quick');
    var dataEl = card.querySelector('script[data-lr-variants]');
    if (!btn || !panel || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sizeIdx = data.sizeIndex, colourIdx = data.colourIndex;
    var state = { colour: null };
    var colourRow = panel.querySelector('[data-lr-colours]');
    var sizeRow = panel.querySelector('[data-lr-sizes]');
    var msg = panel.querySelector('.lr-quick__msg');

    function opt(v, idx) { return idx >= 0 ? v.options[idx] : null; }

    function renderSizes() {
      sizeRow.innerHTML = '';
      var seen = {};
      data.variants.forEach(function (v) {
        if (colourIdx >= 0 && state.colour !== null && opt(v, colourIdx) !== state.colour) return;
        var label = sizeIdx >= 0 ? opt(v, sizeIdx) : v.title;
        if (seen[label]) return;
        seen[label] = true;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lr-chip';
        b.textContent = label;
        b.disabled = !v.available;
        b.addEventListener('click', function () { add(v.id, b); });
        sizeRow.appendChild(b);
      });
    }

    function renderColours() {
      if (!colourRow || colourIdx < 0) return;
      colourRow.innerHTML = '';
      data.colours.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lr-chip';
        b.textContent = c;
        b.setAttribute('aria-pressed', state.colour === c ? 'true' : 'false');
        b.addEventListener('click', function () { state.colour = c; renderColours(); renderSizes(); });
        colourRow.appendChild(b);
      });
    }

    function add(id, b) {
      b.disabled = true;
      msg.textContent = '';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          b.disabled = false;
          if (!res.ok) { msg.textContent = (res.j && res.j.description) || 'Sorry, that size could not be added.'; return; }
          msg.textContent = 'Added to your bag';
          setTimeout(close, 900);
          openCart();
        })
        .catch(function () { b.disabled = false; msg.textContent = 'Something went wrong, please try again.'; });
    }

    function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }

    btn.addEventListener('click', function () {
      var open = panel.hidden;
      if (open) {
        state.colour = data.colours.length ? data.colours[0] : null;
        renderColours();
        renderSizes();
        msg.textContent = '';
      }
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var x = panel.querySelector('.lr-quick__close');
    if (x) x.addEventListener('click', function () { close(); btn.focus(); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); btn.focus(); } });
  }

  function init(scope) {
    scope = scope || document;
    initTabs(scope);
    initRotate(scope);
    scope.querySelectorAll('.lr-card').forEach(initQuick);
  }

  window.lrInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
